export default __webpack_public_path__ + "static/media/Img0025.e9c5a58a.png";